import React from "react";
import useReveal from "./useReveal";

const SKILL_GROUPS = [
  {
    label: "// languages",
    items: [
      ["TypeScript", true],
      ["JavaScript ES6+", true],
      ["HTML5", false],
      ["CSS3", false],
    ],
  },
  {
    label: "// frameworks & libs",
    items: [
      ["React", true],
      ["Node.js", false],
      ["Tailwind", false],
      ["Storybook", false],
    ],
  },
  {
    label: "// testing",
    items: [
      ["Jest", true],
      ["Cypress", true],
      ["React Testing Library", false],
    ],
  },
  {
    label: "// tooling & practices",
    items: [
      ["Git", false],
      ["Webpack", false],
      ["ESLint", false],
      ["CI/CD", false],
      ["Accessibility (a11y)", false],
      ["Design Systems", false],
      ["Agile", false],
    ],
  },
  {
    label: "// backend / infra",
    items: [
      ["Node.js", false],
      ["REST APIs", false],
      ["Supabase", false],
    ],
  },
  {
    label: "// currently learning",
    items: [
      ["System Design", false],
      ["Backend Architecture", false],
      ["Cloud", false],
    ],
  },
];

const SkillGroup = ({ group, delay }) => {
  const [ref, visible] = useReveal();
  return (
    <div
      ref={ref}
      style={{
        ...s.group,
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(16px)",
        transition: `opacity 0.55s ease ${delay}s, transform 0.55s ease ${delay}s`,
      }}
    >
      <div style={s.groupLabel}>{group.label}</div>
      <div style={s.items}>
        {group.items.map(([name, featured]) => (
          <span
            key={name}
            style={{ ...s.item, ...(featured ? s.featured : {}) }}
          >
            {name}
          </span>
        ))}
      </div>
    </div>
  );
};

const Skills = () => {
  const [labelRef, labelVisible] = useReveal();
  return (
    <section id="skills" className="section-pad" style={s.section}>
      <div
        ref={labelRef}
        style={{ opacity: labelVisible ? 1 : 0, transition: "opacity 0.5s" }}
      >
        <p style={s.label}>
          <span style={s.slash}>//</span> Skills
        </p>
      </div>
      <div className="skills-grid">
        {SKILL_GROUPS.map((g, i) => (
          <SkillGroup key={g.label} group={g} delay={i * 0.07} />
        ))}
      </div>
    </section>
  );
};

const s = {
  section: { maxWidth: 1100, margin: "0 auto" },
  label: {
    fontSize: "0.68rem",
    letterSpacing: "0.2em",
    textTransform: "uppercase",
    color: "var(--accent)",
    marginBottom: "2.5rem",
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
  },
  slash: { color: "var(--muted)" },
  grid: {},
  group: {
    background: "var(--bg2)",
    border: "1px solid var(--border)",
    borderRadius: 6,
    padding: "1.5rem",
  },
  groupLabel: {
    fontSize: "0.65rem",
    letterSpacing: "0.18em",
    textTransform: "uppercase",
    color: "var(--accent)",
    marginBottom: "1rem",
  },
  items: { display: "flex", flexWrap: "wrap", gap: "0.5rem" },
  item: {
    fontSize: "0.75rem",
    border: "1px solid var(--border2)",
    color: "var(--muted2)",
    padding: "5px 11px",
    borderRadius: 3,
    letterSpacing: "0.04em",
  },
  featured: {
    borderColor: "rgba(192,132,252,0.3)",
    color: "var(--accent2)",
    background: "rgba(192,132,252,0.06)",
  },
};

export default Skills;
